import { useNavigator } from '@repo/toolkit/use-navigator'
import Box from '@repo/ui/box'
import { TravelTwoIcon } from '@repo/ui/icons'
import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

import { createTrip } from '../../api/trips/create-trip'
import UserNavBar from '../../components/elements/nav-bar'
import TripForm from '../../components/pages/trips/trip-form'
import { Paths } from '../../lib/constants/path'
import { twoButtonsConfig } from '../../lib/utils/buttons-config/validation-buttons-config'
import { showAxiosError } from '../../lib/utils/functions/misc.functions'
import { mapTripInputValues } from './utils'

const TripCreatePage = () => {
  const { navigate, back } = useNavigator()

  const { mutateAsync } = useMutation({
    mutationFn: createTrip,
    onError: showAxiosError,
    onSuccess: () => toast.success('Voyage créé avec succès')
  })

  return (
    <div>
      <UserNavBar title={'Créer un voyage'} icon={TravelTwoIcon} />
      <div className={'h-4'} />

      <Box>
        <TripForm
          defaultValues={{ hasTransport: true }}
          buttonsConfig={twoButtonsConfig({
            onConfirm: async (values) => {
              const res = await mutateAsync(mapTripInputValues(values))
              navigate(Paths.TRIP_UPDATE_PAGE.replace(':id', res.id.toString()), { replace: true })
            },
            onCancel: () => back()
          })}
        />
      </Box>
    </div>
  )
}

export default TripCreatePage
